module.exports = __webpack_public_path__ + "static/media/gen_de_gas_emp.89eda127.png";